export default __webpack_public_path__ + "static/media/CNo.69-1.01c34ab0.jpg";